import * as angular from "angular";
import {IController} from 'angular';
import {AgentModel} from "../../angular/models/agent.model";

export class AccountAddMultiItemCtrl implements IController {

  agent: AgentModel;
  isSelected: boolean;
  isDisabled: boolean;

  onToggle: Function;

  $onInit() {
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentAddMultiItem', {
    bindings: {
      agent: '<',
      isSelected: '<?',
      isDisabled: '<?',
      onToggle: '&'
    },
    template: require('./agent-add-multi-item.html').default,
    controller: AccountAddMultiItemCtrl
  });
